import axios from 'axios';

const selectors = {
  loadMore: '[data-load-more]',
  listingBody: '.header__mega-menu',
};

  
export default function init ({ el, context }) {

	const nodeSelectors = {
    loadMore: document.querySelector(selectors.loadMore),
    listingBody: el
  }

	const getArticlesHtml = async (baseUrl, templateHandle, newPageNumber) => {
    debugger
    return await axios.get(`${baseUrl}?view=${templateHandle}&page=${newPageNumber}`)
  }

  const updateBody = async (newPageNumber) => {
    let baseUrl = el.dataset.baseUrl
    let templateHandle = el.dataset.templateHandle
  	let html = await getArticlesHtml(baseUrl, templateHandle, newPageNumber)
  	if(html.data === ""){
  		nodeSelectors.loadMore.innerText = "No more articles"
  		nodeSelectors.loadMore.disabled = true
  	} else {
  		nodeSelectors.listingBody.innerHTML = nodeSelectors.listingBody.innerHTML + html.data;
  	}	
  }

  nodeSelectors.loadMore.addEventListener('click', async (event) => {
  	event.preventDefault();
  	let pageNumber = parseInt(el.dataset.page)
  	let newPageNumber = pageNumber + 1
  	el.dataset.page = newPageNumber
  	updateBody(newPageNumber);
  });

}